import Skeleton from "react-loading-skeleton";

const CountdownClockLoader = () => {
  return (
    <article className="xs:hidden sm:block">
      <Skeleton highlightColor="rgb(255, 130, 0)" width={700} containerClassName={`h-8 flex justify-center mb-4`} />
      <Skeleton containerClassName={`h-12 flex justify-center`} highlightColor="#f1f1f1" width={400} />
    </article>
  );
};

export default CountdownClockLoader;
